module.exports = __webpack_public_path__ + "static/media/andrew.709b3ccb.png";